export enum TransactionStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  SCHEDULED = 'scheduled',
  PROCESSING = 'processing',
  TRIAGE = 'triage',
  VOID = 'void',
}
